import React from 'react';
import './Hero.scss';
import { Typography } from 'antd';
const Hero = ({ 
    title = '', 
    subtitle = '', 
    children,
    width = 952, 
    negativeMargin = true,
}) => {
  return (
    <div className={`hero-section ${negativeMargin ? 'negativeMargin' : ''}`}>
      <div className="hero-padding">
        <div className="hero-content" style={{ width: '95%', maxWidth: width }}>
          <Typography.Title className="title">
            {title}
          </Typography.Title>
          <Typography.Text className="subtitle">
            {subtitle}
          </Typography.Text>
          <Typography.Paragraph className="content">
            {children}
          </Typography.Paragraph>
        </div>
      </div>
    </div>
  )

}

export default Hero;